<div
  class="tp-wrap"
  [class.disabled]="disabled"
  [ngClass]="customClass"
  [style.height]="height"
>
  <div
    class="tp-trigger"
    [class.open]="isOpen"
    [class.error]="hasError"
    [style.height]="height"
    [style.width]="width"
  >
    <!-- <mat-icon class="clock-icon">schedule</mat-icon> -->

    <input
      #hourRef
      class="seg"
      type="text"
      inputmode="numeric"
      maxlength="2"
      placeholder="00"
      [value]="hourInput"
      [attr.disabled]="disabled ? true : null"
      (input)="onHourInput($event)"
      (blur)="onHourBlur()"
      (keydown)="onHourKeydown($event)"
      (focus)="onHourFocus(); openDropdown()"
    />

    <span class="colon">:</span>

    <input
      #minuteRef
      class="seg"
      type="text"
      inputmode="numeric"
      maxlength="2"
      placeholder="00"
      [value]="minuteInput"
      [attr.disabled]="disabled ? true : null"
      (input)="onMinuteInput($event)"
      (blur)="onMinuteBlur()"
      (keydown)="onMinuteKeydown($event)"
      (focus)="onMinuteFocus(); openDropdown()"
    />

    <mat-icon
      class="toggle-icon"
      (click)="isOpen ? cancelDropdown() : openDropdown()"
    >
      schedule
    </mat-icon>
  </div>

  <!-- Error -->
  <div class="err-msg" *ngIf="hasError">{{ errorMessage }}</div>

  <!-- Dropdown -->
  <div class="tp-dropdown" *ngIf="isOpen">
    <div class="cols">
      <!-- Hour column -->
      <div class="col">
        <div class="col-head">ชั่วโมง</div>
        <div class="scroll-list">
          <div
            *ngFor="let h of hours"
            class="opt"
            [class.active]="h === tempHour"
            (click)="selectHour(h)"
          >
            {{ pad(h) }}
          </div>
        </div>
      </div>

      <div class="col-div"></div>

      <!-- Minute column -->
      <div class="col">
        <div class="col-head">นาที</div>
        <div class="scroll-list">
          <div
            *ngFor="let m of minutes"
            class="opt"
            [class.active]="m === tempMinute"
            (click)="selectMinute(m)"
          >
            {{ pad(m) }}
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="tp-footer">
      <button mat-button type="button" class="btn-now" (click)="setNow()">
        ตอนนี้
      </button>

      <div class="tp-footer-actions">
        <button
          mat-raised-button
          type="button"
          class="btn-primary btn-sm"
          (click)="confirmDropdown()"
        >
          ตกลง
        </button>
      </div>
    </div>
  </div>
</div>
